import { Filter } from "../filter-definition";
import {
  Modal,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import FiltersModal from "./FiltersModal";
import { useRequestParams } from "contexts/RequestParamsProvider";
import FilterButton from "components/FilterButton";

const FiltersButtonWithModal = ({ filters }: { filters: Filter[] }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { hasSelectedFilters, isUsingInitialFilters } = useRequestParams();

  return (
    <>
      <FilterButton onClick={onOpen} hasSelectedFilters={hasSelectedFilters} />

      <Modal isOpen={isOpen} onClose={onClose} size="xs">
        <ModalOverlay />
        <ModalContent>
          <FiltersModal
            filters={filters}
            isUsingInitialFilters={isUsingInitialFilters}
          />
        </ModalContent>
      </Modal>
    </>
  );
};

export default FiltersButtonWithModal;
